import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AbstractDialogService, canDismissWhenNotSwiped, DialogOptions } from '@examdojo/core/dialog';
import { mapToVoid } from '@examdojo/rxjs';
import { SolutionCaptureQueryParam } from '@examdojo/solution';
import { catchError, from, switchMap } from 'rxjs';
import { RootUrlParts } from '../../../../app.model';
import { TopicPracticeDialogContainerComponent } from './topic-practice-dialog-container.component';

@Injectable({ providedIn: 'root' })
export class TopicPracticeDialogService extends AbstractDialogService {
  readonly router = inject(Router);
  readonly id = 'topic-practice-dialog';
  readonly component = TopicPracticeDialogContainerComponent;

  override options: DialogOptions = {
    cssClass: 'modified-modal font-primary fullscreen',
    backdropDismiss: false,
    handle: false,
    breakpoints: undefined,
    initialBreakpoint: undefined,
    canDismiss: canDismissWhenNotSwiped,
  };

  dismissPracticeActivityDialog(redirectTo?: string) {
    return from(
      this.router.navigate([redirectTo || `/${RootUrlParts.TopicPractice}`], {
        queryParams: {
          [SolutionCaptureQueryParam]: undefined,
        },
        queryParamsHandling: 'merge',
      }),
    ).pipe(
      switchMap(() => this.dismiss()),
      catchError(() => this.dismiss()),
      mapToVoid(),
    );
  }
}
